<!-- 合作单位 查询新增 -->
<template>
<div class="page-form">
    <PageBack :title="title" />
    <div class="detail-wrap">
        <el-form :model="searchForm" ref="searchForm"  :inline="true"> 
            <!-- <el-form-item label="单位名称" prop="productName">
                <el-input style="width: 200px;" v-model="searchForm.productName"></el-input>
            </el-form-item>  -->
            <el-form-item>
                <!-- <el-button type="primary" @click="searchQuery('searchForm')">查询</el-button>
                <el-button @click="resetForm('searchForm')">重置</el-button> -->
                <el-button type="success" @click="handleAdd" v-if="adminRoles">添加合作单位</el-button>
            </el-form-item>          
        </el-form>
        <el-table border :data="tableData" style="width: 100%;">
            <el-table-column  prop="index"   label="序号"   width="50" align="center"/>     
            <el-table-column  prop="name"  label="单位名称" width="180"  align="center"/>  
            <el-table-column  prop="type"  label="单位类型" width="120"  align="center"/>                    
            <el-table-column  prop="des"   label="描述"  align="center"/>
            <el-table-column  prop="imageUrl"   label="图片"  align="center" >
                <template slot-scope="scope">
                    <span v-if="scope.row.imageUrl===''">暂无</span>
                    <el-image :src="scope.row.imageUrl" :preview-src-list="scope.row.srcList" v-else></el-image>
                </template>              
            </el-table-column>
            <el-table-column  fixed="right" label="操作" width="120">
                <template slot-scope="scope">                   
                    <el-button @click="handleUpdate(scope.row)" type="text" 
                    size="small" v-if="roles==='管理员'">编辑</el-button>
                    <el-button @click="handleCancel(scope.row)" type="text" 
                    size="small" v-if="roles==='管理员'">刪除</el-button>                  
                </template>
            </el-table-column>
            </el-table>
             <pagination
                style="text-align:right"
                v-show="total > 10"
                :total="total"
                :page.sync="queryParams.page"
                :limit.sync="queryParams.pagesize"
                @pagination="initData"
            />
            <AddCompany :title="goodsDialogTitle" 
            v-if="isShowGoods"
            :formData="goodsForm" 
            :count="total"
            @close="closeDialog"
            @confirm="handleConfirm"></AddCompany>
    </div>
</div>
</template>

<script>
import PageBack from '@/components/PageHeader'
import pagination  from '@/components/Pagination'
import AddCompany from './components/AddCompany.vue';
export default {
    components: {
        PageBack,
        pagination,
        AddCompany
    },
    data() {
        return {
            isShowGoods: false,
            isShowGoodsSpec: false,
            isShowGoodsSpecDetail: false,
            searchForm:{
                productName: '',
                certType: '',
                status: ''
            },
            queryParams:{
                page: 1,
                pagesize: 10
            },
            tableData: [],
            total: 0,
            typeOption: [],
            isDialogVisible: false,
            titleForm: '',
            goodsForm: {},
            goodsSpecForm: {},
            goodsSpecDetailForm: [],
            goodsDialogTitle: '',
            goodsSpecDialogTitle: ''
        }
    },
     computed: {
        title() {
            return this.$route.meta.title
        },
        roles(){
            return localStorage.getItem('roles')
        }, 
        adminRoles(){
            let value = localStorage.getItem('roles')
            if(value === '管理员'){
                return true
            }else{
                return false
            }            
        }, 
    },
    created() {
        // this.getType()
        this.initData()
    },
    mounted() {

    },
    methods: {
        initData(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 33,
            }
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    let arr= res.Data.DataTable
                    this.total = res.Data.SumCount
                    if(arr.length > 0){
                        this.tableData = arr.map(item=>{
                        let imageUrl = item['图片'] ? this.$global.uploadUrl +item['图片']: ''
                            return{
                                index: item['词条索引'],
                                name: item['中文描述'],
                                imageUrl: imageUrl,
                                mainImageUrl: item['图片'],
                                des: item['备注'],
                                srcList: [imageUrl],
                                type: item.v_type,
                            }
                        })    
                    }else{
                        this.tableData = []
                    }                                 
                }
            })
        },
        handleAdd(){
            this.isShowGoods = true
            this.goodsDialogTitle = '添加单位'
            this.goodsForm = {}
        },
        handleConfirm(){
            this.initData()
        },
        closeDialog(){
            this.isShowGoods = false        
        },
        // 更新
        handleUpdate(obj){           
            this.isShowGoods = true
            this.goodsDialogTitle = '更新单位'
            this.goodsForm = obj
        },
        // 删除
        handleCancel(obj){
            this.$confirm('确定删除吗？','警告',).then(res=>{
               this.confirmDelete(obj)
            }).catch(err=>{
                console.log(err)
            })
        },
        confirmDelete(obj){         
            let params = {
                opcode: 43,
                i_no: 33,
                v_name: obj.index,
                flag: 3,
                v_caption: '',
                v_summary: '',               
                v_imasges: ''
            }
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    this.$message.success('删除成功')
                    this.initData()            
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        searchQuery(){
            // this.initData()
        }
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
</style>


// WEBPACK FOOTER //
// src/views/admin/cooperator.vue